import PanelCard from '@components/display/cards/PanelCard';
import { Button } from '@components/utility/buttons';
import { EOrderApiTabValues } from '@developers/types/EOrderApi';
import { Box, List, ListItem, ListItemText, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

const BulletPoints: Record<EOrderApiTabValues, { title: React.ReactNode; list: JSX.Element[] }> = {
    [EOrderApiTabValues.PersonalizedData]: {
        title: <FormattedMessage id="developers.eorderapi.personalized_data" defaultMessage="Personalized Data" />,
        list: [
            <FormattedMessage id="developers.eorderapi.custom_pricing" defaultMessage="Custom Pricing" />,
            <FormattedMessage id="developers.eorderapi.orders_and_backorders" defaultMessage="Orders and backorders" />,
            <FormattedMessage id="developers.eorderapi.invoices" defaultMessage="Invoices" />,
            <FormattedMessage id="developers.eorderapi.shipping_details" defaultMessage="Shipping Details" />,
            <FormattedMessage
                id="developers.eorderapi.return_merchandise_authorizations"
                defaultMessage="Return Merchandise Authorizations (RMAs)"
            />,
        ],
    },
    [EOrderApiTabValues.ComprehensiveProductInformation]: {
        title: (
            <FormattedMessage
                id="developers.eorderapi.comprehensive_product_information"
                defaultMessage="Comprehensive Product Information"
            />
        ),
        list: [
            <FormattedMessage
                id="developers.eorderapi.technical_specifications"
                defaultMessage="Technical specifications, about the (inner) working of the product"
            />,
            <FormattedMessage
                id="developers.eorderapi.high_resolution_product_images"
                defaultMessage="High-resolution product images"
            />,
            <FormattedMessage
                id="developers.eorderapi.product_related_documents"
                defaultMessage="Product-related documents"
            />,
            <FormattedMessage
                id="developers.eorderapi.logistic_and_administrative_attributes"
                defaultMessage="Logistic and administrative attributes (e.g. dimensions)"
            />,
            <FormattedMessage
                id="developers.eorderapi.gtin_intrastat_and_end_user_price_lists"
                defaultMessage="GTIN, Intrastat codes, and end-user price lists"
            />,
        ],
    },
    [EOrderApiTabValues.StockAvailabilityUpdates]: {
        title: (
            <FormattedMessage
                id="developers.eorderapi.stock_availability_updates"
                defaultMessage="Stock Availability Updates"
            />
        ),
        list: [
            <FormattedMessage
                id="developers.eorderapi.real_time_stock_levels"
                defaultMessage="Real-time stock levels per SKU"
            />,
            <FormattedMessage
                id="developers.eorderapi.stock_availability_primary_warehouse"
                defaultMessage="Stock availability from your primary warehouse"
            />,
            <FormattedMessage
                id="developers.eorderapi.stock_levels_all_victron_warehouses"
                defaultMessage="Stock levels across all Victron warehouses"
            />,
        ],
    },
};

export const EOrderAPITabContent = ({ tab }: { tab: EOrderApiTabValues }) => {
    return (
        <>
            <PanelCard
                component="article"
                header={BulletPoints[tab].title}
                body={
                    <List className="list-disc pl-6 py-0">
                        {BulletPoints[tab].list.map((text, index) => (
                            <ListItem key={index} className="list-item">
                                <ListItemText>{text}</ListItemText>
                            </ListItem>
                        ))}
                    </List>
                }
            />
            <PanelCard
                component="aside"
                header={
                    <FormattedMessage
                        id="developers.eorderapi.documentation_access"
                        defaultMessage="Documentation Access"
                    />
                }
                body={
                    <Typography>
                        <FormattedMessage
                            id="developers.eorderapi.documentation_access_body"
                            defaultMessage="Get complete API documentation with examples, authentication guides, and integration tutorials. Login with your E-Order Credentials to access the full documentation portal"
                        />
                    </Typography>
                }
                cta={
                    <Box className="mt-auto pt-[26px]">
                        <Button
                            fullWidth
                            fullRounded
                            href="https://eorder.victronenergy.com/api-webhook-settings/api-keys/"
                            target="_blank"
                        >
                            <FormattedMessage
                                id="developers.eorderapi.documentation_access_button"
                                defaultMessage="Access Documentation"
                            />
                        </Button>
                    </Box>
                }
            />
        </>
    );
};
